import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // 引入 useLocation
import Cookies from 'js-cookie';
import { getCookieToken, tokenInfo } from './apiList/apiToken';

const useTokenCheck = () => {
    const [tokenPayload, setTokenPayload] = useState({ nickName: '', isLogin: false, isRegister: false, isCanExecute: false });
    const navigate = useNavigate();
    const location = useLocation(); // 使用 useLocation 來獲取當前路徑

    useEffect(() => {
        const checkToken = async () => {
            try {
                const currentToken = await getCookieToken();
                let payload = { nickName: '', isLogin: false, isRegister: false, isCanExecute: false };

                const fullPath = `${location.pathname}${location.search}`;
                console.log('Current Full Path:', fullPath);

                if (currentToken) {
                    const tokenValid = await tokenInfo(currentToken);

                    if (!tokenValid.isValid) {
                        console.log("Token is not valid or expired.");
                        Cookies.remove("Token");
                        getCookieToken(); // 重新下載一次
                    } else {
                        payload.nickName = tokenValid?.data?.user?.nickName || '';
                        var isLogin = tokenValid?.data?.isLogin || false;
                        var isRegister = tokenValid?.data?.isRegister || false;
                    }


                    let isCanExecute = true;


                    if (!isLogin) {
                        if (location.pathname !== '/lineLogin') {
                            navigate('/lineLogin');
                            isCanExecute = false;
                        }
                    } else if (!isRegister) {
                        if (location.pathname !== '/Register' || location.search !== '?action=new') {
                            navigate('/Register?action=new');
                            isCanExecute = false;
                        }
                    }

                    payload.isLogin = isLogin;
                    payload.isRegister = isRegister;
                    payload.isCanExecute = isCanExecute;
                } else {
                    navigate('/lineLogin');
                }
                setTokenPayload(payload);
            } catch (error) {
                console.error('Error checking token:', error);
                let payload = { nickName: '', isCanExecute: false };
                setTokenPayload(payload);
                navigate('/lineLogin');
            }
        };

        checkToken();
    }, [navigate]);

    return tokenPayload;
};

export { useTokenCheck };
